import styled from "styled-components";

export default styled.div`
   {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0px;
    min-height: 66vh;

    .home-txt-container,
    .home-img-container {
      width: 48%;
    }

    .home-img-container {
      img {
        border-radius: 8px;
      }
    }

    .home-txt-container {
      font-family: "Raleway", sans-serif;
      h3 {
        color: black;
      }
      p {
        font-size: 1.1em;
        color: grey;
      }
    }

    .home-links-container {
      font-family: "Raleway", sans-serif;
    }
  }

  @media (max-width: 1200px) {
  }
  @media (max-width: 992px) {
  }
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 20px 2px;
    .home-txt-container,
    .home-img-container {
      width: 100%;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/styles/StyledHome.js